import Slider from 'react-slick';   
import  './MarketSlide.css';
import React, { useState, useEffect, useRef } from 'react';
const PrevArrow = (props) => (
    <button {...props} className="slick-prev">
      <img src="/img/Marketplace/arrow_left.svg" alt="Previous" width="30" />
    </button>
  );
  
  const NextArrow = (props) => (
    <button {...props} className="slick-next">
      <img src="/img/Marketplace/arrow_right.svg" alt="Next" width="30" />
    </button>
  );


const MarketSlide = ()=>{ 

    const sliderRef = useRef(null);
    const totalSlides = 5;
    const [currentSlide, setCurrentSlide] = useState(0);
  
    const [progress, setProgress] = useState(0);
    const animationRef = useRef(null);
    const startTimeRef = useRef(null);

    useEffect(() => {
        const duration = 6000; // in milliseconds
        const start = (currentSlide / totalSlides) * 100;
        const end = ((currentSlide + 1) / totalSlides) * 100;
      
        cancelAnimationFrame(animationRef.current);
        startTimeRef.current = null;
      
        const animate = (timestamp) => {
          if (!startTimeRef.current) startTimeRef.current = timestamp;
          const elapsed = timestamp - startTimeRef.current;
          const progressPercent = Math.min(start + ((end - start) * (elapsed / duration)), end);
      
          setProgress(progressPercent);
      
          if (elapsed < duration) {
            animationRef.current = requestAnimationFrame(animate);
          }
        };
      
        animationRef.current = requestAnimationFrame(animate);
      
        return () => cancelAnimationFrame(animationRef.current);
      }, [currentSlide]);
      


// START slick
    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        centerPadding: '30px',
        prevArrow: <PrevArrow />,
        nextArrow: <NextArrow />,
        beforeChange: (oldIndex, newIndex) => {
            setCurrentSlide(newIndex);
          },

        afterChange: (newIndex) => {
            setCurrentSlide(newIndex);
          },

        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 1, // Correcting the key to 'slidesToShow'
              infinite: false,
              centerPadding: "30px",
              margin: 30,
            },
          },

          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1, // Correcting the key to 'slidesToShow'
              margin: 20,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1, // Correcting the key to 'slidesToShow'
            },
          },
     
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 1, // Correcting the key to 'slidesToShow'
            },
          },
  
        ],
      };
// END slick

const [isPlaying, setIsPlaying] = useState(true);
const togglePlay = () => {
    if (isPlaying) {
      sliderRef.current?.slickPause();
    } else {
      sliderRef.current?.slickPlay();
    }
    setIsPlaying(!isPlaying);
  };

    return(
        <>


            <div className="sliderProgressMain">

                <Slider {...settings} ref={sliderRef} className="marketSlideDetailOuter">
                    <div class="item">
                        <div class="marketSlideDetail">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabLeft">
                                        {/* <figure>
                                            <img className="img-fluid" src="/img/Marketplace/marketPlaceSlide_11.png" alt="rent id"/>
                                        </figure> */}
                                        <video width="240" height="480" controls loop autoPlay muted playsInline>
                                            <source src="/img/Marketplace/marketPlaceSlide_11.mov" type="video/mp4" />
                                        </video>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabRight">
                                        <h3>Branded App Storefront </h3>
                                        <p>Your brand, featured in the palm of their hand. Guests can explore 
                                        your fleet, book instantly, and rebook from your branded app 
                                        storefront—complete with your logo, colors, and custom policies. 
                                        Built for recognition, trust, and repeat business.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="marketSlideDetail">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabLeft">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/marketPlaceSlide_12.png" alt="rent id"/>
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabRight">
                                        <h3>Website Branded Storefront</h3>
                                        <p>Turn traffic into bookings with your own branded website storefront. 
                                            Fully designed to reflect your business—logo, visuals, policies, and 
                                            promos included. Guests can browse, book, and come back again and again. 
                                            No distractions. Just your brand, front and center.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="marketSlideDetail">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabLeft">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/marketPlaceSlide_13.png" alt="rent id"/>
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabRight">
                                        <h3>Search by Vehicle, Location, Landmark or Host</h3>
                                        <p>The most advanced car rental search on the market—built to deliver speed, 
                                            accuracy, and trust. Guests can search by vehicle, location, landmark, or 
                                            host, with real-time results that surface the best matches closest to them.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="marketSlideDetail">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabLeft">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/marketPlaceSlide_14.png" alt="rent id"/>
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabRight">
                                        <h3>Search by Host</h3>
                                        <p>Guests can search by vehicle, location, landmark, or host to find the perfect 
                                            fit. Whether they’re looking for a specific car or reconnecting with an operator 
                                            they trust, your branded storefront—complete with your logo, policies, and 
                                            fleet—makes rebooking simple and loyalty effortless.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="item">
                        <div class="marketSlideDetail">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabLeft">
                                        <figure>
                                            <img className="img-fluid" src="/img/Marketplace/marketPlaceSlide_15.png" alt="rent id"/>
                                        </figure>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="marketPlaceTabRight">
                                        <h3>Search by Vehcile</h3>
                                        <p>Search by vehicle to find the exact make and model you’re looking for. Whether 
                                            it’s a luxury SUV or a fuel-efficient compact, guests see real-time availability 
                                            and location—surfacing the closest match to them instantly.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                </Slider> 

                <div className="sliderProgressOuter">
                    <button className="slider-play-btn" onClick={togglePlay}> 
                        <img
                            src={
                            isPlaying
                                ? '/img/Marketplace/pause.svg'   // Pause icon when autoplay is active
                                : '/img/Marketplace/play.svg' // Play icon when autoplay is paused
                            }
                            alt={isPlaying ? 'Pause' : 'Play'}
                        />
                    </button>
                    <div className="slider-progress-bar">
  <div className="slider-progress" style={{ width: `${progress}%` }}></div>
</div>
                </div>
            </div>
        </>
    )
}

export default MarketSlide;